// @ts-nocheck
import { Button } from '@pwc/pwc-deals-ui';
import { isReportLivePreview } from 'common/helpers/featureFlags';
import { FC, useMemo } from 'react';
import PanelButton from './PanelButton';
import { RibbonButtonTypeProps } from './RibbonPanelButton';

type Props = {
  commentPanelOpened: boolean;
  commentCountLabel: string;
  totalCommentsRendered: number;
  hasCommentSelection: boolean;
  handlePanelButtonClick: (type: RibbonButtonTypeProps) => void;
  onClose: () => void;
};

const CommentPanelHeader: FC<Props> = ({
  commentCountLabel,
  commentPanelOpened,
  totalCommentsRendered,
  hasCommentSelection,
  handlePanelButtonClick,
  onClose,
}) => {
  const commentPanelHeaderClassName = useMemo(() => {
    // if (!isReportLivePreview) {
    //   if (!commentPanelOpened) {
    //     return 'comment-panel-header ribbon-panel';
    //   }
    //   return 'comment-panel-header';
    // }
    return commentPanelOpened
      ? 'comment-panel-header opened'
      : 'comment-panel-header';
  }, [commentPanelOpened]);

  return (
    <div className={commentPanelHeaderClassName}>
      {commentPanelOpened && (
        <div
          className="comment-panel-header__label"
          role="heading"
          aria-level={1}
          data-testid="comment-panel-header__label"
        >
          {commentCountLabel} ({totalCommentsRendered})
        </div>
      )}

      <Button
        className="panel-button"
        aria-label="comment icon"
        data-testid="panel-button"
        onClick={isReportLivePreview ? onClose : handlePanelButtonClick}
        disabled={hasCommentSelection && commentPanelOpened}
        icon={undefined}
        iconClasses={undefined}
      >
        <PanelButton isPanelOpened={commentPanelOpened} />
      </Button>
    </div>
  );
};

export default CommentPanelHeader;
